<template>
  <div style="height: 100%">
    <init-loading :isInitLoading.sync='isInitLoading'></init-loading>
    <div>
      <el-row>
        <el-col :span='24'>
          <el-form :model='searchCondition' inline>
            <!--              <el-form-item label="负责人" prop="leader_id">-->
            <!--                <UserSelect :leader-id.sync="searchCondition.leader_id"  @selected="selectedLeader"/>-->
            <!--              </el-form-item>-->
            <el-form-item>
              <el-date-picker
                v-model='searchCondition.ym'
                type='month'
                @change='handleQuery'
                value-format='yyyy-MM'
                format='yyyy年MM月'
                placeholder='选择月份' style='width: 140px'>
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <artist-search @handleSelect='selectArtist' style='width: 200px;display: inline;margin-right: 10px' />
            </el-form-item>
            <el-form-item>
              <el-input v-model='searchCondition.leader_name' clearable placeholder='发起人：支持模糊搜索'
                        @change='handleQuery'></el-input>
            </el-form-item>
            <el-form-item>
              <el-select v-model='searchCondition.progress_status' style='width: 120px' @change='handleQuery'
                         clearable>
                <el-option :label='option.label' :value='option.value' v-for='(option,key) in progressStatusOptions'
                           :key='key'
                           :style='`text-align: center;border-radius: 3px;margin:1px;border: #DCDFE6 1px solid;background-color:${option.color_value};width:150px;padding:0 10px`'></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type='primary' @click='handleQuery' icon='el-icon-search'>查询</el-button>
              <el-button type='primary' @click='handleAdd' icon='el-icon-plus'
                         v-if="userPermissions.indexOf('lb_kol_create')>-1">添加排期
              </el-button>
            </el-form-item>
            <el-form-item v-if="userPermissions.indexOf('lb_kol_limit_config__add')>-1">
              <kol-select-count></kol-select-count>
            </el-form-item>
            <el-form-item>
              <RecycleList v-if='userPermissions.indexOf("lb_kol_restore")>-1' key='recycleListKol' ref='refRecycleList' lb-type='1' @changed='handleQuery'></RecycleList>
            </el-form-item>
            <el-form-item style='float: right'>
              <!--                <span>共<b>{{ total }}</b>个排期</span>&nbsp;&nbsp;-->
              <!-- 响应式显示：宽度小于1375时显示图标，否则显示radio group -->
              <div v-if="isMobileView" class="icon-view-group">
                <el-tooltip content="日历展示" placement="top">
                  <i
                    :class="['icon-view-item', mod === 'Calendar' ? 'active' : '']"
                    @click="mod = 'Calendar'"
                  >
                    <svg t="1739066587000" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1234" width="16" height="16"><path d="M896 128h-128v64h128v704H128V192h128v-64H128c-35.2 0-64 28.8-64 64v704c0 35.2 28.8 64 64 64h768c35.2 0 64-28.8 64-64V192c0-35.2-28.8-64-64-64z" p-id="1235" fill="#666666"></path><path d="M320 64h-64v128h64V64z m448 0h-64v128h64V64zM384 512h256v64H384z m0 128h256v64H384z m0 128h256v64H384z" p-id="1236" fill="#666666"></path></svg>
                  </i>
                </el-tooltip>
                <el-tooltip content="列表展示" placement="top">
                  <i
                    :class="['icon-view-item', mod === 'Table' ? 'active' : '']"
                    @click="mod = 'Table'"
                  >
                    <svg t="1739066637000" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2234" width="16" height="16"><path d="M128 128h768v768H128z" fill="#FFFFFF" p-id="2235"></path><path d="M896 128H128c-35.2 0-64 28.8-64 64v640c0 35.2 28.8 64 64 64h768c35.2 0 64-28.8 64-64V192c0-35.2-28.8-64-64-64z m0 704H128V192h768v640z" p-id="2236" fill="#666666"></path><path d="M192 256h640v64H192zM192 384h640v64H192zM192 512h640v64H192zM192 640h640v64H192z" p-id="2237" fill="#666666"></path></svg>
                  </i>
                </el-tooltip>
                <el-tooltip content="我参与的" placement="top">
                  <i
                    :class="['icon-view-item', mod === 'Mine' ? 'active' : '']"
                    @click="mod = 'Mine'"
                  >
                    <svg t="1739066687000" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3234" width="16" height="16"><path d="M512 512m-256 0a256 256 0 1 0 512 0 256 256 0 1 0-512 0Z" fill="#FFFFFF" p-id="3235"></path><path d="M512 128c-211.2 0-384 172.8-384 384s172.8 384 384 384 384-172.8 384-384-172.8-384-384-384z m0 704c-176 0-320-144-320-320s144-320 320-320 320 144 320 320-144 320-320 320z" p-id="3236" fill="#666666"></path><path d="M512 288c-123.2 0-224 100.8-224 224s100.8 224 224 224 224-100.8 224-224-100.8-224-224-224z m0 384c-88 0-160-72-160-160s72-160 160-160 160 72 160 160-72 160-160 160z" p-id="3237" fill="#666666"></path><path d="M512 512m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z" p-id="3238" fill="#666666"></path></svg>
                  </i>
                </el-tooltip>
              </div>
              <el-radio-group v-model='mod' v-else>
                <el-radio-button label='Calendar'>日历展示</el-radio-button>
                <el-radio-button label='Table'>列表展示</el-radio-button>
                <el-radio-button label='Mine'>我参与的</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>

    <!--    创建直播排期-->
    <CreateEdit :visible.sync='open' @close='handleQuery' :id='currId' :default-form-data='defaultFormData'/>

    <!--    日志-->
    <LbScheduleLog :info-id='currId' :visible.sync='openLog'/>
    <!--    <DialogSelectDressProduct :dressRow="dressRow" @close="dressClose"-->
    <!--                              :visible.sync='openDress'></DialogSelectDressProduct>-->


    <!--      日历展示-->
    <!--                <ScheduleCalendar ref='refScheduleCalendar' :search-condition.sync='searchCondition'-->
    <!--                                  v-if="mod==='Calendar'" :lb-type='1' :progress-status-options='progressStatusOptions'-->
    <!--                                  @dragEdit='dragEdit' @handleCmd='handleCmd'-->
    <!--                                  :total.sync='total'-->
    <!--                />-->

    <!--      列表展示-->
    <ScheduleTable ref='refScheduleTable' :lb-type='1' :mod='mod' :data='dataList'
                   :search-condition='searchCondition'
                   v-if="mod==='Table'"
                   @handleCmd='handleCmd' :progress-status-options='progressStatusOptions'
                   :total.sync='total'
    />
    <ScheduleTable ref='refScheduleMineTable' :lb-type='1' :mod='mod' :data='dataList'
                   :search-condition='searchCondition'
                   v-if="mod==='Mine'"
                   @handleCmd='handleCmd' :progress-status-options='progressStatusOptions'
                   :total.sync='total'
    />
    <!--                更新后的日历-->
    <CalendarView ref='refScheduleCalendar' :search-condition.sync='searchCondition'
                  v-if="mod==='Calendar'" :lb-type='1' :progress-status-options='progressStatusOptions'
                  @dragEdit='dragEdit' @handleCmd='handleCmd'
                  :total.sync='total'
    />
  </div>

</template>

<script>
import ScheduleCalendar from '@/pages/lb/kol/ScheduleCalendarClassic/ScheduleCalendar'
import ScheduleTable from './ScheduleTable'
import ArtistSearchCustom from '@/components/artist/ArtistSearchCustom'
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import CreateEdit from '@/pages/lb/kol/CreateEdit'
import ApeDrawer from '@/components/ApeDrawer'
import LbScheduleLog from '@/pages/lb/LbScheduleLog'
import LeaderSearch from '@/pages/lb/components/LeaderSearch'
import UserSelect from '@/pages/lb/components/UserSelect'
import {mapGetters} from 'vuex'
import InitLoading from '@/components/InitLoading.vue'
// import DialogSelectDressProduct from '@/pages/lb/dress/DialogSelectDressProduct.vue'
import ArtistSearch from '@/components/artist/ArtistSearch'
import RecycleList from '@/pages/lb/components/RecycleList'
import KolSelectCount from "@/pages/lb/kol/kolSelectCount.vue";
import ExportLbProductPpt from "@/pages/lb/selection_ack/ExportLbProductPpt.vue";
import CalendarView from "@/pages/lb/kol/ScheduleCalendar/CalendarView.vue"


export default {
  name: 'LbKolIndex',
  components: {
    ExportLbProductPpt,
    KolSelectCount,
    RecycleList,
    InitLoading,
    UserSelect,
    LeaderSearch,
    LbScheduleLog,
    ApeDrawer,
    CreateEdit,
    PageHeaderLayout,
    ArtistSearchCustom,
    ScheduleCalendar,
    ScheduleTable,
    ArtistSearch,
    CalendarView
  },
  computed: {
    ...mapGetters(['userPermissions'])
  },
  data() {
    return {
      total: 0,
      mod: 'Calendar',
      searchCondition: { ym: null, artist_id: null, leader_id: '', progress_status: null, mod: this.mod },//
      dataList: [],//直播数据列表
      open: false,
      dialogTitle: '直播排期',
      openLog: false,//日志模态框
      currId: null,
      orderSort: { start_at: 'desc', id: 'desc' },//默认排序规则
      defaultFormData: {},
      progressStatusOptions: [
        { label: '新创建', value: 1, color_value: '#fffff', class_name: 'status-new' },
        { label: '已发需求', value: 2, color_value: '#D0F6E0', class_name: 'status-launch' },
        { label: '初选完成', value: 3, color_value: '#DCEBFF', class_name: 'status-original' },
        { label: '确认完成', value: 4, color_value: '#FFECD0', class_name: 'status-ack' },
        { label: '确认完成', value: 4, color_value: '#FFECD0', class_name: 'status-ack' },
        { label: '锁定表格', value: 5, color_value: '#FFE4E9', class_name: 'status-lock' }
      ],
      isInitLoading: true,
      openDress: false,
      dressRow: {},
      windowWidth: 0, // 添加窗口宽度响应式数据
      isMobileView: false, // 添加移动视图状态
    }
  },
  watch: {
    // 'searchCondition.ym': {
    //   immediate: true,
    //   handler(val) {
    //     if (val) {
    //       let ymArr = val.split('-')
    //       this.searchCondition.year = parseInt(ymArr[0])
    //       this.searchCondition.month = parseInt(ymArr[1])
    //       this.handleQuery()
    //     }
    //   }
    // },
    mod: {
      handler(val) {
        this.searchCondition.mod = val
        this.$nextTick(() => {
          this.handleQuery()
        })
      }
    }
  },
  methods: {
    dragEdit(val) {
      if (val) {
        this.handleQuery()
      }
    },
    defaultTime() {
      const end = new Date()
      //年份选择：默认当月
      this.searchCondition.ym = end.getFullYear() + '-' + (end.getMonth() + 1)
    },

    selectArtist(selectInfo) {
      if (selectInfo) {
        this.searchCondition.artist_id = selectInfo.id
        this.searchCondition.nickname = selectInfo.nickname
        this.searchCondition.group_id = selectInfo.group_id
        this.searchCondition.group_name = selectInfo.group_name
      } else {
        this.searchCondition.artist_id = null
        this.searchCondition.nickname = null
        this.searchCondition.group_id = null
        this.searchCondition.group_name = null
      }

      this.handleQuery()
    },
    // 处理搜索条件
    handleSearchCondition() {
      const condition = {}
      if (this.searchCondition.ym) {
        condition.ym = this.searchCondition.ym
      }
      if (this.searchCondition.artist_id) {
        condition.artist_id = this.searchCondition.artist_id
      }
      if (this.searchCondition.progress_status) {
        condition.progress_status = this.searchCondition.progress_status
      }
      if (this.searchCondition.leader_id) {
        condition.leader_id = this.searchCondition.leader_id
      }
      if (this.searchCondition.leader_name) {
        condition.leader_name = this.searchCondition.leader_name
      }

      return condition
    },
    handleQuery() {
      if (this.mod === 'Calendar') {
        if (this.$refs['refScheduleCalendar'])
          this.$refs['refScheduleCalendar'].handleQuery()

      } else if (this.mod === 'Table') {
        if (this.$refs['refScheduleTable'])
          this.$refs['refScheduleTable'].handleQuery()
      } else {
        if (this.$refs['refScheduleMineTable'])
          this.$refs['refScheduleMineTable'].handleQuery()
      }
      this.isInitLoading = false

      // this.$notify.info('查询')
      // let searchCondition = this.handleSearchCondition()
      // Object.assign(searchCondition, { order: this.orderSort })
      // let { list } = await this.$api.getLbScheduleMonthList(searchCondition)
      // this.dataList = list
    },
    handleAdd(data) {
      this.currId = null
      // let date = data.date ? data.date : data.fullDate
      if (data) {
        this.defaultFormData = { start_at: null }
      }

      this.open = true
    },
    showLog(row) {
      this.currId = row.id || null
      this.openLog = true
    },
    showNotify(row) {
      this.currId = row.id || null
      this.open = true
    },
    isDing() {
      const ua = window.navigator.userAgent
      return ua.indexOf('DingTalk') !== -1 // true or false
    },
    jumpToPage(pageName, params) {
      // this.$router.push({
      //   name: pageName,
      //   params: params,
      //   query: params
      // })
      if (pageName === 'lbKolDetail' && this.isDing()) {
        this.$router.push({
          name: pageName,
          params: params

        })
      } else {
        const { href } = this.$router.resolve({
          name: pageName,
          params: params
        })
        window.open(href, '_blank')
      }
    },
    selectProduct(row) {
      this.currId = row.id || null
      this.jumpToPage('productSelection', { lb_id: row.id })
    },
    async delInfo(id) {
      const info = await this.$api.delLbSchedule(id)
      if (info) {
        await this.handleQuery()
        this.msgSuccess('删除成功')
      }
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const id = row.id
      this.$confirm(`是否确认删除排期【${row.date}/${row.nickname}/${row.platform_name}】?`, '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.delInfo(id)
      }).catch(() => {
        this.msgWarn('取消操作')
      })
    },
    async handleCmd(cmd, row) {
      // 'weixin_vedio'
      let canView
      // this.$emit('handleCmd',cmd,this.currentRow)
      switch (cmd) {
        case 'detail':
          this.jumpToPage('lbKolDetail', { id: row.id })
          break
        case 'selection':
          // this.$notify.info('查看选品')
          this.selectProduct(row)
          break
        // case 'selection_ack':
        //   // this.$notify.info('查看选品-确认')
        //   this.jumpToPage('productSelectionAck', { 'id': row.id })
        //   break
        case 'create':
          // this.$notify.info('添加排期'+JSON.stringify(row))
          this.handleAdd(row)
          break
        case 'log':
          this.showLog(row)
          break
        case 'delete':
          this.handleDelete(row)
          break
        case 'dress':
          if (row.id) {
            canView = await this.isCheckLbDressSelectionView(row.id)
            if (canView) {
              /*      this.dressRow = {
                      id: row.id,
                      nickname: row.nickname,
                      date: row.date,
                      platform_name: row.platform_name
                    }*/
              // this.openDress = true
              const params = {
                id: row.id,
                nickname: row.nickname,
                date: row.date,
                platform_name: row.platform_name
              }
              if (this.isDing()) {
                await this.$router.push({
                  name: 'productDressKol',
                  params: params
                })
              } else {
                const { href } = this.$router.resolve({
                  name: 'productDressKol',
                  params: params
                })
                window.open(href, '_blank')
              }
            } else this.$message.error('只有选品排期创建人所在组的成员可以进入')
          } else this.$message.error('暂无服饰选品')
          // this.$notify.info('查看排期')
          break
          // case 'notify':
        //   this.$notify.info('通知')
        //   this.showNotify(row)
        //   break;
      }
    },
    async isCheckLbDressSelectionView(id) {
      const data = await this.$api.checkLbDressSelectionView(id)
      return data.can_view === 1
    },
    // checkLbDressSelectionView
    selectedLeader(item) {
      this.searchCondition.leader_id = item.value
      this.handleQuery()
    },
    dressClose() {
      this.dressRow = {},
        this.openDress = false
    },
    handleResize() {
      // 更新窗口宽度和移动视图状态
      this.windowWidth = window.innerWidth
      this.isMobileView = this.windowWidth < 1375
      // 重新计算动态高度
      this.calculateDynamicHeight()
      // 为小屏幕设备添加自动滚动
      this.addAutoScrollForSmallScreen()
    },
    calculateDynamicHeight() {
      this.$nextTick(() => {
        const viewportHeight = window.innerHeight

        // 1. #page-content 固定高度
        const pageContent = document.querySelector('#page-content')
        if (pageContent) {
          if (!this._pageContentOriginal) {
            this._pageContentOriginal = {
              height: pageContent.style.height,
              minHeight: pageContent.style.minHeight,
              overflow: pageContent.style.overflow
            }
          }
          pageContent.style.setProperty('height', `${viewportHeight - 92}px`, 'important')
          pageContent.style.setProperty('min-height', 'auto', 'important')
          pageContent.style.setProperty('overflow', 'hidden', 'important')
        }

        // 2. 获取 menu-container 实际高度
        const menuContainer = document.querySelector('.menu-container')
        let menuHeight = 0
        if (menuContainer) {
          menuHeight = menuContainer.offsetHeight
        }

        // 3. main-content_bg 精确填满剩余空间
        const mainContentBg = document.querySelector('.LbScheduleKol_main-content')
        if (mainContentBg) {
          if (!this._mainContentOriginal) {
            this._mainContentOriginal = {
              height: mainContentBg.style.height,
              minHeight: mainContentBg.style.minHeight,
              overflow: mainContentBg.style.overflow,
              display: mainContentBg.style.display,
              flexDirection: mainContentBg.style.flexDirection
            }
          }
          const mainHeight = viewportHeight - 92 - menuHeight
          mainContentBg.style.setProperty('height', `${mainHeight}px`, 'important')
          mainContentBg.style.setProperty('min-height', 'auto', 'important')
          mainContentBg.style.setProperty('overflow', 'hidden', 'important')
          mainContentBg.style.setProperty('display', 'flex', 'important')
          mainContentBg.style.setProperty('flex-direction', 'column', 'important')

          // 4. main-content_bg 的第一个子元素填满并内部滚动
          const rootDiv = mainContentBg.firstElementChild
          if (rootDiv) {
            rootDiv.style.setProperty('flex', '1', 'important')
            rootDiv.style.setProperty('min-height', '0', 'important')
            rootDiv.style.setProperty('overflow', 'hidden', 'important')
          }
        }
      })
    },

    // 为小屏幕设备添加自动滚动功能
    addAutoScrollForSmallScreen() {
      this.$nextTick(() => {
        const mainContent = document.querySelector('.LbScheduleKol_main-content')
        if (mainContent && this.isMobileView) {
          // 为小屏幕设备添加自动滚动样式
          mainContent.style.overflowY = 'auto'
          mainContent.style.overflowX = 'hidden'
          mainContent.style.scrollBehavior = 'smooth'

          // 添加滚动条样式
          mainContent.style.scrollbarWidth = 'thin'
          mainContent.style.scrollbarColor = '#c1c1c1 #f1f1f1'

          // 确保内容可以滚动
          mainContent.style.minHeight = '300px'
        }
        // 大屏分支不再覆盖 overflow（calculateDynamicHeight 已统一设置）
      })
    },

    _restoreStyles() {
      const pageContent = document.querySelector('#page-content')
      if (pageContent && this._pageContentOriginal) {
        pageContent.style.setProperty('height', this._pageContentOriginal.height || '', 'important')
        pageContent.style.setProperty('min-height', this._pageContentOriginal.minHeight || '', 'important')
        pageContent.style.setProperty('overflow', this._pageContentOriginal.overflow || '', 'important')
      }
      const mainContentBg = document.querySelector('.LbScheduleKol_main-content')
      if (mainContentBg && this._mainContentOriginal) {
        mainContentBg.style.setProperty('height', this._mainContentOriginal.height || '', 'important')
        mainContentBg.style.setProperty('min-height', this._mainContentOriginal.minHeight || '', 'important')
        mainContentBg.style.setProperty('overflow', this._mainContentOriginal.overflow || '', 'important')
        mainContentBg.style.setProperty('display', this._mainContentOriginal.display || '', 'important')
        mainContentBg.style.setProperty('flex-direction', this._mainContentOriginal.flexDirection || '', 'important')
      }
      this._pageContentOriginal = null
      this._mainContentOriginal = null
    },

    // 防抖函数
    debounce(func, wait) {
      let timeout
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout)
          func(...args)
        }
        clearTimeout(timeout)
        timeout = setTimeout(later, wait)
      }
    }

  },
  created() {
    this.defaultTime()
  },
  mounted() {
    this.handleQuery()
    this.calculateDynamicHeight()
    // 初始化窗口宽度和移动视图状态
    this.windowWidth = window.innerWidth
    this.isMobileView = this.windowWidth < 1375
    // 为小屏幕设备添加自动滚动
    this.addAutoScrollForSmallScreen()
    // 添加防抖处理，避免频繁触发
    this.debouncedResize = this.debounce(() => {
      this.handleResize()
    }, 250)
    window.addEventListener('resize', this.debouncedResize)
  },
  deactivated() {
    this._restoreStyles()
  },
  activated() {
    this.calculateDynamicHeight()
  },
  beforeDestroy() {
    if (this.debouncedResize) {
      window.removeEventListener('resize', this.debouncedResize)
    }
    this._restoreStyles()
  },
}
</script>

<style lang='scss' scoped>
@import "../style/main.scss";

.lb-kol-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.search-container {
  flex-shrink: 0;
  padding: 16px;
  background: #fff;
  border-radius: 4px;
  margin-bottom: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.responsive-form {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;

  .form-item-responsive {
    margin-bottom: 0;
    flex: 1 1 auto;
    min-width: 150px;
  }

  // 移动端样式
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;

    .form-item-responsive {
      min-width: 100%;
      margin-bottom: 12px;
    }

    .el-form-item {
      width: 100%;
      margin-right: 0 !important;
    }
  }

  // 平板端样式
  @media (min-width: 769px) and (max-width: 1024px) {
    .form-item-responsive {
      min-width: 200px;
    }
  }
}

// 响应式表单元素
.responsive-date-picker {
  width: 100% !important;
  min-width: 140px;
}

.responsive-artist-search {
  width: 100% !important;
  min-width: 200px;
}

.responsive-input {
  width: 100% !important;
  min-width: 180px;
}

.responsive-select {
  width: 100% !important;
  min-width: 120px;
}

// 按钮组响应式
.el-form-item:has(.el-button) {
  @media (max-width: 768px) {
    display: flex;
    gap: 8px;

    .el-button {
      flex: 1;
    }
  }
}

// 右侧视图切换组响应式
.el-form-item[style*="float: right"] {
  @media (max-width: 768px) {
    float: none !important;
    width: 100%;
    margin-top: 12px;
    display: flex;
    justify-content: center;
  }
}

.icon-view-group {
  display: flex;
  gap: 8px;
  align-items: center;

  .icon-view-item {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s ease;
    background-color: #FFFFFF;

    &:hover {
      border-color: #409EFF;
      background-color: #F5F7FA;
    }

    &.active {
      border-color: #ff3176;
      background-color: #ff3176;

      .icon {
        path {
          fill: #FFFFFF !important;
        }
      }
    }

    .icon {
      width: 16px;
      height: 16px;

      path {
        transition: fill 0.3s ease;
      }
    }
  }
}

// 主内容区域响应式
.LbScheduleKol_main-content {
  flex: 1;
  min-height: 400px;
}

// 移动端优化
@media (max-width: 768px) {
  .search-container {
    padding: 12px;
    margin-bottom: 12px;
  }

  .el-row {
    margin: 0 !important;
  }

  .el-col {
    padding: 0 !important;
  }

  // 隐藏不必要的元素或调整显示
  .el-form-item:has(.kol-select-count),
  .el-form-item:has(.RecycleList) {
    @media (max-width: 480px) {
      display: none;
    }
  }
}

// 超小屏幕优化
@media (max-width: 480px) {
  .search-container {
    padding: 8px;
  }

  .responsive-form {
    gap: 8px;
  }

  .icon-view-group {
    gap: 4px;

    .icon-view-item {
      width: 28px;
      height: 28px;
    }
  }
}
</style>
<style>
/* 全局响应式调整 */
@media (max-width: 1375px) {
  .el-radio-group {
    display: none !important;
  }

  .icon-view-group {
    display: flex !important;
  }

  /* 小屏幕设备自动滚动样式 */
  .LbScheduleKol_main-content {
    overflow-y: auto !important;
    overflow-x: hidden !important;
    scroll-behavior: smooth;
    min-height: 300px;
  }

  /* 自定义滚动条样式 */
  .LbScheduleKol_main-content::-webkit-scrollbar {
    width: 6px;
  }

  .LbScheduleKol_main-content::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  .LbScheduleKol_main-content::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
  }

  .LbScheduleKol_main-content::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }

  /* Firefox 滚动条样式 */
  .LbScheduleKol_main-content {
    scrollbar-width: thin;
    scrollbar-color: #c1c1c1 #f1f1f1;
  }
}

@media (min-width: 1376px) {
  .el-radio-group {
    display: inline-flex !important;
  }

  .icon-view-group {
    display: none !important;
  }
}

/* 高度小于800px时启用滚动 */
@media (max-height: 800px) {
  .LbScheduleKol_main-content {
    overflow-y: auto !important;
    overflow-x: hidden !important;
    scroll-behavior: smooth;
    min-height: 300px;
  }

  /* 自定义滚动条样式 */
  .LbScheduleKol_main-content::-webkit-scrollbar {
    width: 6px;
  }

  .LbScheduleKol_main-content::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  .LbScheduleKol_main-content::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
  }

  .LbScheduleKol_main-content::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }

  /* Firefox 滚动条样式 */
  .LbScheduleKol_main-content {
    scrollbar-width: thin;
    scrollbar-color: #c1c1c1 #f1f1f1;
  }
}
.LbScheduleKol_main-inner__content {
  overflow: hidden;
}
</style>
